import { render, staticRenderFns } from "./EconomicGroupDetails.vue?vue&type=template&id=503aa956"
import script from "./EconomicGroupDetails.vue?vue&type=script&lang=js"
export * from "./EconomicGroupDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports